export const env = {
	url: window['env']['API_URL'] || process.env.API_URL,
};
